module.exports = __webpack_public_path__ + "static/img/icon6-10.390696cd.png";